/**
 * Choix exclusif en boutons accoles (« Mes leads | Tous »). Des boutons radio
 * natifs caches visuellement : fleches, Tab et lecteurs d'ecran fonctionnent
 * sans code ; l'etiquette porte le style.
 */
import { useId } from 'react';

export interface OptionSegment<T extends string> {
  valeur: T;
  libelle: string;
}

export function ChoixSegmente<T extends string>({ libelle, options, valeur, onChange, className = '' }: {
  /** Nom accessible du groupe. */
  libelle: string;
  options: readonly OptionSegment<T>[];
  valeur: T;
  onChange: (valeur: T) => void;
  className?: string;
}) {
  const nom = useId();
  return (
    <div role="radiogroup" aria-label={libelle} className={`inline-flex max-w-full rounded-md border border-bordure bg-surface-appuyee p-0.5 ${className}`}>
      {options.map((option) => {
        const coche = option.valeur === valeur;
        return (
          <label
            key={option.valeur}
            className={`inline-flex h-8 cursor-pointer items-center rounded-sm px-3 text-sm font-medium whitespace-nowrap transition-colors has-[:focus-visible]:outline-2 has-[:focus-visible]:outline-offset-1 has-[:focus-visible]:outline-accent-600 ${
              coche ? 'bg-surface text-encre shadow-pose' : 'text-encre-discrete hover:text-encre'
            }`}
          >
            <input type="radio" name={nom} value={option.valeur} checked={coche} onChange={() => onChange(option.valeur)} className="sr-only" />
            {option.libelle}
          </label>
        );
      })}
    </div>
  );
}
